import consumerApi from "api/services/consumer-api";
import { Coordinates } from "custom-types/Coordinates";
import { ApiResponse } from "custom-types/Promotions";
import { Deal } from "custom-types/Deals";
import { stringify } from "qs";

export const getPromotions = async (
  coordinates: Coordinates,
  countryCode = "US",
  skip = 0,
  take = 6
) => {
  const route = "/api/feeds/v1/deals";
  const body = stringify(
    {
      platform: "web",
      format: "raw",
      analytics_category: "global-search",
      analytics_label: "promotions",
      ...coordinates,
      skip,
      take,
    },
    {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
    }
  );

  try {
    const { data } = await consumerApi.get<ApiResponse>(`${route}?${body}`, {
      headers: {
        "x-country-code": countryCode,
      },
    });

    const mappedToDealStructure = data.map((promo) => {
      const {
        imageUrl,
        title,
        dispensaryId,
        dispensaryName,
        dispensarySlug,
        distance,
      } = promo;

      return {
        imageUrl: decodeURIComponent(imageUrl || ""),
        title,
        dispensary: {
          id: dispensaryId,
          name: dispensaryName,
          slug: dispensarySlug,
          distanceMi: distance,
        },
      } as Deal;
    });

    return { promotions: mappedToDealStructure };
  } catch {
    return { promotions: [] };
  }
};
